<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="1560"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Tambah Undangan

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-3">
          <ValidationObserver 
            ref="form">
            <v-form>

              <undangan_form :form="form" :anggota="anggota" :process="process" :template="template" :kepaniteraan="kepaniteraan"></undangan_form>

            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="indigo"
            :disable="form.meta_json_object.content === ''"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            @click="reset_template(); dialog.form_template = true;">
            <v-icon small class="mr-1">mdi-plus-circle-outline</v-icon>
            Tambah Template
          </v-btn>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.pdf_preview"
      @keydown.esc="dialog.pdf_preview = false; dialog.form = true;"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          Preview {{ selected.preview.title }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.pdf_preview = false; dialog.fullscreen = false; selected.preview = {};"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">

          <div>
            <div>
              <div
                class="body-2 font-italic">
                *Jika ingin menggunakan Kop Surat, silahkan pilih di bawah ini :
              </div>

              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <v-select
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    placeholder="Pilih Kop Surat"
                    
                    :items="kop_surat"
                    item-value="id"
                    item-text="title"
                    :item-color="set_color"

                    clearable
                    @click:clear="form.kop_surat_id = ''; form.kop_surat_url_image = ''; form.kop_surat_url_image = '';"
                    

                    v-model="form.kop_surat_id"
                    :success="form.kop_surat_id !== ''"
                    required
                    class="mb-3"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="form.kop_surat_id !== ''">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </v-col>

                <v-col
                  cols="12"
                  md="5">
                  <v-select
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    placeholder="Pilih Ukuran Kertas"
                    
                    :items="[
                      {
                        text: 'A4',
                        value: 'a4'
                      },
                      {
                        text: 'Folio',
                        value: 'folio'
                      },
                      {
                        text: 'Folio',
                        value: 'folio'
                      }
                    ]"
                    item-value="value"
                    item-text="text"
                    :item-color="set_color"
                    
                    v-model="form.ukuran_kertas"
                    :success="form.ukuran_kertas !== ''"
                    required
                    class="mb-3"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="form.ukuran_kertas !== ''">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

            </div>

            <v-card
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
              id="arsippdf"
                ref="arsippdf"
                :style="form.ukuran_kertas === 'a4' ? 'height: 1122.519685px' : 'height: 1247.2440945px'">
                <undangan_preview :selected="selected" :form="form" :anggota="anggota" :process="process"></undangan_preview>
              </div>
            </v-card>

          </div>

        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="exportToPDF()">
            <v-icon small class="mr-1">mdi-file-download-outline</v-icon>
            Download
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.pdf_preview = false; dialog.fullscreen = false; selected.preview = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.template"
      @keydown.esc="dialog.template = false"
      v-if="dialog.template"
      :fullscreen="dialog.fullscreen"
      width="1560"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Template Undangan

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.template = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-3">
          <ValidationObserver 
            ref="form">
            <v-form>

              <undangan_template :template="template" :process="process" @todata="fetchTemplate()"></undangan_template>

            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.template = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form_template"
      @keydown.esc="dialog.form_template = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form_template = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form_template">
            <v-form>

              <ValidationProvider 
                name="name" 
                :rules="'required'" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama Template
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Undangan Rapat"

                  v-uppercase

                  v-model="template_name"
                  :success="template_name !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 70%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama Template {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="template_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.template"
            :loading="process.template"
            v-on:keyup.enter="save_template()"
            @click="save_template()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.template"
            @click="dialog.form_template = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.preview_all"
      @keydown.esc="dialog.preview_all = false; dialog.form = true;"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          Dowload Semua

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.preview_all = false; dialog.fullscreen = false; selected.preview = {};"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">

          <div>
            <div>
              <div
                class="body-2 font-italic">
                *Jika ingin menggunakan Kop Surat, silahkan pilih di bawah ini :
              </div>

              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <v-select
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    placeholder="Pilih Kop Surat"
                    
                    :items="kop_surat"
                    item-value="id"
                    item-text="title"
                    :item-color="set_color"

                    clearable
                    @click:clear="form.kop_surat_id = ''; form.kop_surat_url_image = ''; form.kop_surat_url_image = '';"
                    

                    v-model="form.kop_surat_id"
                    :success="form.kop_surat_id !== ''"
                    required
                    class="mb-3"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="form.kop_surat_id !== ''">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </v-col>

                <v-col
                  cols="12"
                  md="5">
                  <v-select
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    placeholder="Pilih Ukuran Kertas"
                    
                    :items="[
                      {
                        text: 'A4',
                        value: 'a4'
                      },
                      {
                        text: 'Folio',
                        value: 'folio'
                      },
                      {
                        text: 'Folio',
                        value: 'folio'
                      }
                    ]"
                    item-value="value"
                    item-text="text"
                    :item-color="set_color"
                    
                    v-model="form.ukuran_kertas"
                    :success="form.ukuran_kertas !== ''"
                    required
                    class="mb-3"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="form.ukuran_kertas !== ''">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

            </div>

            <v-card
              flat
              v-for="(item, index) in penerima_surat" :key="index" class="mb-5"
              style="border: 2px solid #f0f0f0; border-radius: 10px; top: 12px;">
              <div
                :id="`arsippdf${index}`"
                :ref="`arsippdf${index}`"
                >
                <div>
                  <v-card
                    flat>
                    <div :style="form.ukuran_kertas === 'a4' ? 'height: 1122.519685px' : 'height: 1247.2440945px'">
                      <div v-if="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null"
                          style="margin-bottom: 16px !important;">
                          <v-img 
                          contain
                          width="100%"
                          height="auto"
                          alt="umb" 
                          :src="form.kop_surat_url_image">
                          <template v-slot:placeholder>
                              <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                              </v-progress-circular>
                              </v-row>
                          </template>
                          </v-img>
                      </div>
                
                      <div
                        :style="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null ? 'padding: 0px 38px 0px 38px;' : 'padding: 38px;'">
                
                        <v-card-text
                          class="black--text py-2">
                          <v-row>
                            <v-col
                              cols="12"
                              md="7" style="padding-bottom: 0px;">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="2"
                                  class="py-0 pr-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important; padding-right: 0px !important">
                                  Nomor
                                </v-col>
                
                                <v-col
                                  cols="12"
                                  md="10"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : {{ list[0].meta_json_object.nomor !== '' ? list[0].meta_json_object.nomor : '__________' }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              md="5"
                              style="text-align: right !important; padding-bottom: 0px;">
                              <div>
                                Yogyakarta, {{ list[0].meta_json_object.tanggal | fulldate }}
                              </div>
                            </v-col>
                            <v-col
                              cols="12"
                              md="7" style="padding-top: 0px;">
                
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="2"
                                  class="py-0 pr-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important; padding-right: 0px !important">
                                  Hal
                                </v-col>
                
                                <v-col
                                  cols="12"
                                  md="10"
                                  class="py-0"
                                  style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                  : <span style="font-weight: 700;">{{ list[0].meta_json_object.hal !== '' ? list[0].meta_json_object.hal : '__________' }}</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                
                          <v-row>
                            <v-col
                              cols="12"
                              md="7">
                            </v-col>
                            <v-col
                              cols="12"
                              md="5">
                              <div
                                class="mt-6"
                                style="margin-top: 24px !important;">
                                <div
                                  style="margin-bottom: 1px;">
                                  Kepada 
                                </div>
                
                                <div
                                  style="margin-bottom: 1px;" >
                                  Yth. 
                                  <span>
                                    {{ item !== '' ? item : nama_penerima_surat[index] }}
                                  </span>
                                </div>
                
                                <div
                                  style="margin-bottom: 1px;">
                                  di Yogyakarta
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                
                
                          <div
                            class="mt-10"
                            style="margin-top: 40px !important;">
                            <div>
                              <div class="ql-editor" v-html="list[0].meta_json_object.content"></div>
                            </div>
                          </div>
                
                          <v-row
                            justify="end"
                            class="mt-8"
                            style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                            <v-col
                              cols="12"
                              md="6"
                              class="text-center"
                              style="text-align: center !important;">
                
                              <div
                                >
                                {{ list[0].meta_json_object.jabatan_penandatangan !== '' ? list[0].meta_json_object.jabatan_penandatangan : '__________' }}
                              </div>
                
                              <div v-if="list[0].meta_json_object.image_ttd === ''" style="margin-bottom: 64px !important;">
                
                              </div>
                              <div v-else>
                                <v-img
                                  contain
                                  height="100"
                                  width="100"
                                  :src="list[0].meta_json_object.image_ttd" 
                                  :alt="list[0].meta_json_object.image_ttd"
                                  class="text-center d-flex align-center"
                                  style="margin-left: auto; margin-right: auto; padding-top: 4px; padding-bottom: 4px;">
                                </v-img>
                              </div>
                
                              <div>
                                {{ list[0].meta_json_object.nama_penandatangan !== '' ? list[0].meta_json_object.nama_penandatangan : '__________' }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </div>
                
                      <div v-if="form.kop_surat_url_image_footer !== '' && form.kop_surat_url_image_footer !== null"
                          style="margin-top: 16px !important;">
                          <v-img 
                          style="position: absolute; bottom: 0;"
                          contain
                          width="100%"
                          height="auto"
                          alt="umb" 
                          :src="form.kop_surat_url_image_footer">
                          <template v-slot:placeholder>
                              <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                              </v-progress-circular>
                              </v-row>
                          </template>
                          </v-img>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
            </v-card>

          </div>

        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="exportToPDFAll()">
            <v-icon small class="mr-1">mdi-file-download-outline</v-icon>
            Download
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.preview_all = false; dialog.fullscreen = false; selected.preview = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row
      class="pa-0">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
          <v-card-text class="pt-1 pb-2 px-0">
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">

                <div class="mr-3">
                  <v-btn
                    @click="dialog.preview_all = true; toPreview(list[0]);"
                    elevation="0"
                    :disabled="list.length < 1"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                     Download Semua
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length === 1 && hak_akses_menu.action.preview"
                  class="mr-3" >
                  <v-btn 
                    elevation="0"
                    style="background: #2196f333; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="dialog.pdf_preview = true; toPreview(selected.row[0]);">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Preview
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length > 0 && hak_akses_menu.action.delete"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="background: #f4403433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-uppercase

                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            mobile-breakpoint="0"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '265px' : '193px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="optionsDetail"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              <div
                v-bind:key="header.value">
                <div v-if="header.format !== 'regex'">
                  {{ rowFormat(header.format, value) }} 
                </div>

                <div v-if="header.format === 'regex'">
                  <v-img
                    alt="pakualaman" 
                    width="300"
                    height="150"
                    contain
                    :src="value"
                    class="d-flex align-center text-center">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </div>  
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination" :display="paginationList"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      },
    },
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          delete: false,

          attachment: false,
          map: false,
          detail: false,
          pdf_preview: false,
          template: false,
          form_template: false,
          preview_all: false
        },
        search: '',
        template_name: '',
        selected: {
          row: [],
          freeze: [],
          delete: [],
          pegawai: '',
          option: 'pegawai',
          preview: {},
        },

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },

        optionsDetail: {},
        headers: [],
        list: [],
        category: [],
        user: [],
        anggota: [],
        group: [],
        template: [],
        kop_surat: [],
        group_user: [],
        kepaniteraan: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },

        autocomplete: {
          user: ''
        },
        
        upload: {
          folder: null,
          folder_footer: null
        },

        picker: false,
        form: {
          number: '',
          title: '',
          for: [
            {
            option: 'pegawai',
            name: '',
            }
          ],
          meta_json_object: {
            nomor: '',
            hal: '',
            content: '<p>Dengan Hormat,</p><p><br></p><p>Mengharapkan Kehadiran Nandalem/Bapak/Ibu/Saudara pada:</p><p><br></p><p class="ql-indent-1">Hari, Tanggal	: Kemis Kliwon, 1 Agustus 2024</p><p class="ql-indent-1">Pukul					: 13:15 WIB</p><p class="ql-indent-1">Tempat				: Gedhong Danawara, Pura Pakualaman</p><p class="ql-indent-1">Acara					: Rapat Siraman Pusaka Kadipaten Pakualaman</p><p><br></p><p>Atas Kehadirannya Nandalem/Bapak/Ibu/Saudara, kami sampaikan terima kasih.</p>',
            tanggal: new Date().toISOString().substr(0, 10),
            nama_penandatangan: '',
            jabatan_penandatangan: '',
            image_ttd: '',
          },
          kepaniteraan_id: '',
          kop_surat_id: '',
          kop_surat_url_image: '',
          kop_surat_url_image_footer: '',

          ukuran_kertas: 'a4'
        },
        penerima_surat: [],
        nama_penerima_surat: [],
        paginationList: {},
        process: {
          load: false,
          form: false,
          image: false,
          category: false,
          user: false,
          delete: false,
          print: false,
          detail: false,
          image: false,
          kop: false,
          template: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      undangan_template: () => import(/* webpackPrefetch: true */ '@/components/undangan/template'),
      undangan_form: () => import(/* webpackPrefetch: true */ '@/components/undangan/form'),
      undangan_preview: () => import(/* webpackPrefetch: true */ '@/components/undangan/preview'),
      undangan_preview_all: () => import(/* webpackPrefetch: true */ '@/components/undangan/preview_all'),
    },
    computed: {
      user_logs () {
        return this.$store.state.user
      },
      hak_akses_menu () {
        let menu = {}
        this.$store.state.menu.map(item => {
          if (item.id === 17) {
            menu = item
          }
        })
        return menu
      },

      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      set_filter () {
        return this.$store.state.filter
      }
    },
    watch: {
      'optionsDetail': {
        handler () {
          let pages = 1

          if (this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0) {
            this.limit = parseInt(this.objectFine().limit)
            pages = this.objectFine().page
            // this.options.sortBy[0] = this.objectFine().sort
            // this.options.sortDesc[0] = this.objectFine().order_by === 'ASC' ? true : false
            this.search = this.objectFine().search
          }
          
          // let pagination = { row: this.limit, page: 1 }

          let pagination = { row: this.limit, page: pages }

          this.fetch(pagination)
        },
        deep: true
      },

      'form.kop_surat_id': function () {
        if (this.form.kop_surat_id !== '') {
          this.fetchDetailKopSurat(this.form.kop_surat_id)
        }
      }
    },
    mounted () {
      // this.fetchTemplate()
      // this.fetchKepaniteraan()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          data = value
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Kontak'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetchAnggota () {

        let params = {
          // path: this.$route.fullPath,
          // pagination_bool: false
          limit: 1000,
        }

        await get('admin/user', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.anggota = res.results.data
          }
        })
      },

      toPreview (item) {
        this.selected.preview = item

        this.selected.preview.meta_json_object.image_ttd = ''

        this.form.kop_surat_id = ''
        this.form.kop_surat_url_image = ''
        this.form.kop_surat_url_image_footer = ''

        this.form.ukuran_kertas = 'a4'

        this.fetchKopSurat()

        this.fetchDetail(item.id)
      },
      async fetchKopSurat () {
        this.process.kop = true

        let params = {
          // path: this.$route.fullPath,
          // pagination_bool: false
          limit: 100,
        }

        await get('admin/kop/data', { params })
        .then(response => {
          let res = response.data
            this.process.kop = false
          if (res.status === 200) {
            this.kop_surat = res.results.data
          }
        })
      },

      async fetchDetailKopSurat (id) {
        let params = {
          // path: this.$route.fullPath,
          id: id
        }

        await get('admin/kop/detail', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.form.kop_surat_url_image = res.results.data.header_image_base64
            this.form.kop_surat_url_image_footer = res.results.data.footer_image_base64
          }
        })
      },

      async fetchTemplate (id) {
        let params = {
          limit: 1000,
        }
        this.process.template = true

        await get('admin/template_undangan/data', { params })
        .then(response => {
          let res = response.data
          this.process.template = false
          if (res.status === 200) {
            this.template = res.results.data
          }
        })
      },
      async fetchKepaniteraan (id) {
        let params = {
          limit: 1000,
        }

        await get('admin/kepaniteraan/data', { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.kepaniteraan = res.results.data
          }
        })
      },
      
      async fetchDetail (id) {
        let params = {
          path: this.$route.fullPath,
          id: id
        }

        await get('admin/undangan/detail', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.selected.preview.meta_json_object.image_ttd = res.results.data.ttd_base64
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true
        this.paginationList = {
          page: pagination.page,
          row: pagination.row
        }

        this.limit = pagination.row

        let params = {
          path: `${this.$route.fullPath}/detail`,

          // limit: pagination.row,
          // page: pagination.page,
          pagnation_bool: false,
          sort: this.optionsDetail.sortBy.length < 1 ? '-id' : this.optionsDetail.sortBy[0],
          order_by: this.optionsDetail.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          number: this.detail.number
        }

        TokenService.saveFilter(JSON.stringify(this.objectReplacer(this.set_filter, params)))
        this.$store.commit("setFilter", this.objectReplacer(this.set_filter, params))

        this.selected.row = []

        await get('admin/undangan/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Undangan',
                width: '200px',
                value: 'title',
                freeze: false,
                hide: false
              },
              {
                text: 'Penerima',
                width: '200px',
                value: 'for',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Kalenggahan',
                width: '200px',
                value: 'kalenggahan_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Nomor Surat',
                width: '200px',
                value: 'number',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal Input',
                width: '200px',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Input Oleh',
                width: '200px',
                value: 'user_input_name',
                sortable: false,
                freeze: true,
                hide: false
              }
            ]

            this.penerima_surat = []

            let nama_user = []
            let nama_kalenggahan = []

            res.results.data.map(obj => {
              nama_user.push(obj.for)
            })

            res.results.data.map(obj => {
              nama_kalenggahan.push(obj.kalenggahan_name)
            })

            this.penerima_surat = nama_kalenggahan.length > 0 ? nama_kalenggahan : nama_user
            this.nama_penerima_surat = nama_user
            
            this.list = res.results.data
            this.pagination = res.results.pagination
            // this.fetchAnggota()

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      objectReplacer (arrayOfObjects, newObject) {
        let index = arrayOfObjects.findIndex((obj) => obj.path === newObject.path)

        if (index === -1) {
          arrayOfObjects.push(newObject)
        } else {
          arrayOfObjects[index] = newObject
        }

        return arrayOfObjects
      },
      objectFine () {
        let self = this

        let data = this.set_filter.filter(function(v) {
          return self.$route.fullPath == v.path
        })

        return data.length > 0 ? data[0] : []
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      reset_template (item) {
        if (this.$refs.form_template) this.$refs.form_template.reset()
        this.template_name = ''
        this.process.template = false

        this.message.error = ''
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        // this.selected.pegawai = ''
        this.fetchAnggota()

        // this.selected.option = 'pegawai'
        
        this.form = {
          title: '',
          number: '',
          for: [
            {
              option: 'pegawai',
              name: '',
              kalenggahan_name: '',
            },
          ],
          meta_json_object: {
            nomor: '',
            hal: '',
            content: '<p>Dengan Hormat,</p><p><br></p><p>Mengharapkan Kehadiran Nandalem/Bapak/Ibu/Saudara pada:</p><p><br></p><p class="ql-indent-1">Hari, Tanggal	: Kemis Kliwon, 1 Agustus 2024</p><p class="ql-indent-1">Pukul					: 13:15 WIB</p><p class="ql-indent-1">Tempat				: Gedhong Danawara, Pura Pakualaman</p><p class="ql-indent-1">Acara					: Rapat Siraman Pusaka Kadipaten Pakualaman</p><p><br></p><p>Atas Kehadirannya Nandalem/Bapak/Ibu/Saudara, kami sampaikan terima kasih.</p>',
            tanggal: new Date().toISOString().substr(0, 10),
            nama_penandatangan: '',
            jabatan_penandatangan: '',
            image_ttd: '',
          },
          kepaniteraan_id: '',
          kop_surat_id: '',
          kop_surat_url_image: '',
          kop_surat_url_image_footer: '',

          ukuran_kertas: 'a4'
        }

        this.picker = false

        this.process.form = false

        this.message.error = ''

        // if (this.dialog.form) this.fetchCategory()
      },
      getGeoLocation() {
        if (this.form.id === '') {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        } else {
          this.center = {
            lat: this.form.latitude,
            lng: this.form.longitude
          }
        }
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()


        if (isValid) {
          this.process.form = true

          let url = 'admin/undangan/add'

          this.form.meta_json_object.nomor = this.form.number

          // SAVE TO REST API
          await post(url, {
            data: {
              title: this.form.meta_json_object.hal,
              number: this.form.number,
              for: this.form.for.map(item => {
                return item.name
              }),
              meta_json_object: this.form.meta_json_object,
              ttd_url: this.form.meta_json_object.image_ttd,
              kepaniteraan_id: this.form.kepaniteraan_id
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_template () {
        this.message.error = ''

        const isValid = await this.$refs.form_template.validate()


        if (isValid) {
          this.process.template = true

          let url = 'admin/template_undangan/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              name: this.template_name,
              content: this.form.meta_json_object.content
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.template = false

            if (res.status === 200) {
              this.dialog.form_template = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset_template()

              this.fetchTemplate()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/undangan/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },

      exportToPDF () {
        this.process.form = true

        if (this.selected.preview.template_id != 0) {
          let filename = `Undangan-${this.detail.title}-${this.selected.preview.kalenggahan_name !== '' ? this.selected.preview.kalenggahan_name : this.selected.preview.for }-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`

          let margin_top = this.form.ukuran_kertas === 'a4' ? 1 : 10
          html2pdf(this.$refs.arsippdf, {
            // margin: 0.2,
            margin: this.form.kop_surat_url_image !== '' && this.form.kop_surat_url_image !== null ? [0, 0, 0, 0] : [margin_top, 0, 0, 0],
            filename: filename,
            image: { 
              type: 'jpeg', 
              quality: 0.98
            },
            html2canvas: { 
              dpi: 192, 
              letterRendering: true,
              useCORS: true
            },
            jsPDF: { 
              // unit: 'in', 
              unit: this.form.ukuran_kertas === 'a4' ? 'cm' : 'mm', 
              format: this.form.ukuran_kertas === 'a4' ? this.form.ukuran_kertas : [210, 330],
              precision: 32,
              orientation: 'portrait'
            }
          })
  
          setTimeout(() => { 
            this.process.form = false
  
            this.dialog.pdf_preview = false
            this.selected.preview = {}
          }, 1000)
        } else {
          window.open(this.selected.preview.url, '_blank')

          this.process.form = false
        }

        // var element = document.getElementById('arsippdf')

        // var opt = {
        //   // image:        { type: 'jpeg', quality: 0.98 },
        //   // html2canvas:  { scale: 3 },
        //   // jsPDF:        { unit: 'cm', format: 'letter', orientation: 'portrait' }

        //   margin: 0.2,
        //   filename: filename,
        //   image: { 
        //     type: 'jpeg', 
        //     quality: 0.98
        //   },
        //   html2canvas: { 
        //     dpi: 192, 
        //     letterRendering: true,
        //     useCORS: true
        //   },
        //   jsPDF: { 
        //     unit: 'in', 
        //     format: 'letter', 
        //     orientation: 'portrait'
        //   }
        // }

        // html2pdf().from(filename).set(opt).toPdf().output('datauristring').then(function (pdfAsString) {
        //   console.log(pdfAsString)
        //   // var arr = pdfAsString.split(',')
        //   // pdfAsString= arr[1]

        //   // var data = new FormData()
        //   // data.append("data" , pdfAsString)
        //   // var xhr = new XMLHttpRequest()
        //   // xhr.open('post', 'upload.php', true )
        //   // xhr.send(data)

          
        //   // const url = window.URL.createObjectURL(new Blob([pdfAsString], { type: 'application/pdf' }))
        //   // const link = document.createElement('a')
        //   // link.href = url
        //   // link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
        //   // document.body.appendChild(link)
        //   // link.click()

        //   const metadata = { type: 'application/pdf' }
        //   var blob = new Blob([pdfAsString], metadata)
        //   const file = new File([blob], 'amanata.pdf', metadata)

        //   console.log(blob, file)

        //   let formData = new FormData()
        //       formData.append('key', 'file')
        //       formData.append('file', file)

        //   fetch(`${process.env.VUE_APP_API_CDN}file.php`, {
        //     method: 'POST',
        //     body: formData
        //   })
        //   .then(res => res.json())
        //   .then(response => {
        //     console.log(response)
        //   })
        // })
      },

      exportToPDFAll () {
        this.penerima_surat.map((item, index) => {

          this.process.form = true

        if (this.selected.preview.template_id != 0) {
          let filename = `Undangan-${this.detail.title}-${item}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`

          let margin_top = this.form.ukuran_kertas === 'a4' ? 1 : 10
          // console.log(this.$refs.arsippdf[index])
          html2pdf(this.$refs['arsippdf'+index][0], {
            // margin: 0.2,
            margin: this.form.kop_surat_url_image !== '' && this.form.kop_surat_url_image !== null ? [0, 0, 0, 0] : [margin_top, 0, 0, 0],
            filename: filename,
            image: { 
              type: 'jpeg', 
              quality: 0.98
            },
            html2canvas: { 
              dpi: 192, 
              letterRendering: true,
              useCORS: true
            },
            jsPDF: { 
              // unit: 'in', 
              unit: this.form.ukuran_kertas === 'a4' ? 'cm' : 'mm', 
              format: this.form.ukuran_kertas === 'a4' ? this.form.ukuran_kertas : [210, 330],
              precision: 32,
              orientation: 'portrait'
            }
          })
  
          setTimeout(() => { 
            this.process.form = false
  
            this.dialog.preview_all = false
            this.selected.preview = {}
          }, 1000)
        } else {
          window.open(this.selected.preview.url, '_blank')

          this.process.form = false
        }
        })

      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/report/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },

      // MAP
      toMap () {
        this.markers = []

        this.dialog.map = true

        this.$gmapApiPromiseLazy().then(() => {
          let data = this.selected.row[0]

          this.markers.push({
            title: data.title,
            name: data.user_name,
            attachment: data.attachment,
            datetime: data.datetime,
            latlng: {
              lat: parseFloat(data.latitude), 
              lng: parseFloat(data.longitude)
            },
            icon: {
              url: require('@/assets/image/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[0].latlng : this.center
        })
      },
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent(marker) {
        let data = marker

        data.attachment = data.attachment === '' ? require('@/assets/image/image_default.png') : data.attachment

        return (`
          <div id="iw-container">
            <div class="iw-title">
              ${data.title}
            </div>

            <div class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.attachment}">

              <div class="iw-subTitle" style="margin-bottom: 10px;">
                ${data.name}
              </div>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Tanggal & Waktu
              </p>

              <p style="margin-bottom: 14px; font-weight: bold;">
                ${moment(data.datetime).format('D MMM, YYYY')} Pukul ${moment(data.datetime).format('HH:mm')}
              </p>
            </div>
          </div>
        `)
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>